import { Deserializable } from './deserializable.model';

export class ProductOption implements Deserializable<ProductOption> {
  productId?: string;
  priceId?: string;
  title: string;
  selected: boolean;
  isBundled: boolean;
  description?: string;
  assets?: any;
  quantity?: number;
  unitPrice?: number;
  excludeFromCount?: boolean;

  constructor(input?: Partial<ProductOption>) {
    this.deserialize(input);
  }

  deserialize(input: any): ProductOption {
    if (!input) { return this; }
    Object.assign(this, input);
    return this;
  }
}
